"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var InjectStyles = {
  defaultBody: [{
    margin: 0
  }, "body"],
  globalBoxSizing: [{
    boxSizing: ["inherit"]
  }, "*, :after, :before"]
};
var _default = exports["default"] = InjectStyles;
module.exports = exports.default;